import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatStep, MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Router} from '@angular/router';
import {BsDatepickerConfig, BsDatepickerDirective, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {finalize, firstValueFrom} from 'rxjs';
import {ProfissaoVM} from 'src/app/api/model/profissao/profissaoVM';
import {EntidadeService} from 'src/app/api/module/erp/services/area-logada/entidade/entidade.service';
import {EnumService} from 'src/app/api/module/erp/services/area-logada/enum/enum.service';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {TipoModalAssinaturaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-modal-assinatura';
import {TipoPropostaEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {ListaAuxiliaresService} from 'src/app/api/module/erp/shared/lista-auxiliares/lista-auxiliares.service';
import {CampoDataService} from 'src/app/api/module/erp/shared/services/campoData/campo-data.service';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TabNavigationService} from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import {BeneficiarioPropostaSerice} from 'src/app/api/module/externo/services/proposta/beneficiario.proposta.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
import {VerificaEmail} from 'src/app/components/helper/form-validators/verifica-email';
import {VerificaNome} from 'src/app/components/helper/form-validators/verifica-nome';
import {CustomValidators} from 'src/app/pages/area-logada/shared/validators/custom-validators';
import {FormularioInscricaoEntidadeAdservipComponent} from '../../shared/formulario-inscricao-entidade/entidades/formulario-inscricao-entidade-adservip/formulario-inscricao-entidade-adservip.component';
import {ReducaoCarenciaPropostaComponent} from '../../shared/reducao-carencia-proposta/reducao-carencia-proposta.component';
import {PropostaEntidadeDependenteComponent} from '../proposta-entidade-dependente/proposta-entidade-dependente.component';
import {EnderecoComponent} from 'src/app/pages/area-logada/shared/components/endereco/endereco.component';
@Component({
  selector: 'app-proposta-associado-entidade-beneficiario',
  templateUrl: './proposta-associado-entidade-beneficiario.component.html',
  styleUrls: ['./proposta-associado-entidade-beneficiario.component.scss'],
})
export class PropostaAssociadoEntidadeBeneficiarioComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('formEntidade')
  formEntidade!: FormularioInscricaoEntidadeAdservipComponent;
  @ViewChild('reducaoCarenciaPropostaComponent')
  _reducaoCarenciaPropostaComponent!: ReducaoCarenciaPropostaComponent;
  @ViewChild(EnderecoComponent) enderecoComponent: EnderecoComponent;

  @ViewChild(PropostaEntidadeDependenteComponent)
  _dependenteComponentViewChild!: PropostaEntidadeDependenteComponent;
  @ViewChild('modalManual') modalManual: any;
  @ViewChild('modalSumula21') modalSumula21: any;
  @ViewChild('modalPortabilidade') modalPortabilidade: any;
  @ViewChild('modalReajusteUdemo') modalReajusteUdemo: any;
  @ViewChild('modalReducaoCarencia') modalReducaoCarencia: any;
  @ViewChild('modalFormInscricaoEntidade') modalFormInscricaoEntidade: any;
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChildren(MatStep) steps!: QueryList<MatStep>;
  @ViewChild('datepicker', {static: false}) datepicker?: BsDatepickerDirective;
  @ViewChildren(BsDatepickerDirective)
  datepickersArray!: QueryList<BsDatepickerDirective>;
  @ViewChild('modalConfirmacaoDadosBeneficiarios')
  modalConfirmacaoDadosBeneficiarios: any;
  @ViewChild('modalInformativoParaAssociar')
  modalInformativoParaAssociar: any;
  @Input() heColaborador: boolean = true;
  @Input() somenteLeituraStep: boolean = false;

  checkboxManualBeneficiario = false;
  checkboxSumula = false;
  checkboxPortabilidade = false;
  checkboxReajusteUdemo = false;
  checkboxReducaoCarencia = false;
  // Flags para mostrar sumula ou portabilidade conforme o contrato
  mostrarSumula = false;
  mostrarPortabilidade = false;
  mostrarReducaoCarencia = false;
  blockTemplate: BlockTemplateComponent | undefined;
  listaProfissao!: ProfissaoVM[];
  listaEstatusCivil = new Array<any>();
  listaCidades = new Array<any>();
  listaEstados = new Array<any>();
  listaDeBancosConveniados = new Array<any>();
  listaDeBancosNaoConveniados = new Array<any>();
  formBeneficiario!: FormGroup;
  formGrupDadosBancarios!: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  minDate: Date;
  maxDate: Date;
  isLinear: boolean = false;
  errorMessage: boolean = false;
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  isOtherProfession: boolean = false;
  isOtherGender: boolean = false;
  analiseOperadoraAnterior: boolean = false;
  camposObrigatorioDependente: boolean = true;
  mostrarCampoComponenteDependente: boolean = false;
  mostrarMensagemErroBanco: boolean = false;
  private _beneficiarioPropostaVM: any;
  listaDependentes = new Array<any>();
  acao: number = 0;
  public _listaGeneros: any;
  dadosBeneficiarioDM: any;
  titularDaProposta: string = ''; //Id do titular
  idProposta: string = ''; //Id da proposta
  stepDescriptions: any = '';
  listaEnumTipoProposta: any;
  bancoConveniado: boolean = true;
  modalRef?: BsModalRef;
  listaBancos: any;
  dadosParaCompartilharBeneficiario!: any[];
  stepAtual: number = PropostaExternaEnum.BENEFICIARIO_TITULAR;
  listaCorretora = new Array<any>();
  listaVendedores = new Array<any>();
  isBeneficiary: boolean = true;
  modalManualRef?: BsModalRef;
  modalInscricaoEntidadeRef?: BsModalRef;
  modalSumula21Ref?: BsModalRef;
  modalPortabilidadeRef?: BsModalRef;
  modalReajusteUdemoRef?: BsModalRef;
  modalReducaoCarenciaRef?: BsModalRef;
  ehReducaoCarencia: any;
  listaDeBeneficiarios = new Array<any>();
  entidadeId: any;
  objModalAditivo: any;
  tipoProposta!: TipoPropostaEnum;
  urlEntidade: string = '';
  razaoSocialEntidade: string = '';
  logoEntidade: string = '';
  nomeEntidade: string = '';
  listaBeneficiariosCarencias = new Array<any>();
  checkboxAditivoCarencias: boolean = false;
  entidadeProposta: any;
  codigoProposta: any;
  preleadId: string = '';
  dadosBancariosTitular: any;
  heOdonto: boolean = false;
  tipoProduto!: boolean;
  dadosOperadoraDM: any;
  dependentInclusion: boolean = false;
  inputDataSelecionado: boolean = false;
  retornoDadosFormularioEntidade: any;
  modalConfDadosBeneficiarios?: BsModalRef;
  realizarCadastro: boolean = false;
  propostaAssossiada!: boolean;
  modalInformativoParaAssociarRef?: BsModalRef;
  modalAberto: boolean = false;
  nomeBeneficiario: string = '';
  descricaoTipoProduto: string = '';
  descricaoModalidadeProduto: string = '';
  listaNomeDependenteInvalido: string[] = [];
  jaAssociou_se: boolean = false;
  mostrarOrientacaoPortabilidade: boolean = false;
  mostrarOrientacaoSumula: boolean = false;
  outrosValores = ['outro', 'outros', 'outra', 'outras', 'Outro (Especifique:)'];
  modalidadeProduto: any;
  dataCriacaoProposta: any;
  nomeTitular: any;
  cpfTitular: any;

  constructor(
    private formBuilder: FormBuilder,
    private bsLocaleService: BsLocaleService,
    private _listaAux: ListaAuxiliaresService,
    private _geo: GeoLocalizacaoService,
    private toastr: ToastrService,
    private _beneficiarioProposaService: BeneficiarioPropostaSerice,
    private _propostaCotacaoService: PropostaCotacaoService,
    private _activeRoute: ActivatedRoute,
    private _enumService: EnumService,
    private modalService: BsModalService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _campoDataService: CampoDataService,
    private tabService: TabNavigationService,
    private _spinnerService: SpinnerService,
    private _errorLoggingService: ErrorLoggingService,
    private _router: Router,
    private _entidadeService: EntidadeService,
    private _beneficiarioPropostaService: BeneficiarioPropostaSerice,
    private cdr: ChangeDetectorRef,
  ) {
    this.bsLocaleService.use('pt-br');
    this.minDate = new Date(1900, 0, 1);
    this.maxDate = new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.somenteLeituraStep) {
      this.formBeneficiario && this.formBeneficiario.disable({emitEvent: false});
      this.enderecoComponent?.enderecoForm.disable();
      this.formGrupDadosBancarios && this.formGrupDadosBancarios.disable({emitEvent: false});
    } else {
      this.formBeneficiario && this.formBeneficiario.enable({emitEvent: false});
      this.enderecoComponent?.enderecoForm.enable({emitEvent: false});
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.buscarEnum();
      this.redirecionamentoDeStep(this.stepAtual);
    });
  }

  ngOnInit(): void {
    this.obterIDdaUrl();
    this.criarFormBeneficario();
    this.criarFormDadosBancarios();
    this.buscarProfissao();
    this.buscarListaEstatusCivil();
    this.buscarListaEstados();
    this.buscarBancos();
    this.listaGeneros();
  }

  obterIDdaUrl() {
    let idUrl: any;
    this._activeRoute.paramMap.subscribe(params => {
      idUrl = params.get('idProposta');
      this.idProposta = idUrl;
      this.buscarDadosProposta();
    });
  }

  heAssociado(stepper: MatStepper, heAssociado: boolean) {
    this.iniciarSpinner();
    this.jaAssociou_se = heAssociado;
    this._beneficiarioProposaService
      .associarOperadora(this.idProposta, this.titularDaProposta, heAssociado)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe(
        data => {
          /*
          01-link de inscrição externo == true (ao clicar no botão "Nao sou Associado" na área do beneficiário)
          redireciona para a URL cadastrada na entidade
          02-link de inscrição externo == false,
          O  beneficiário terá que cadastrar o formulário abaixo,
          02.01 - E ja for preenchido ou se ja tiver cadastrado anteriormente,
          pegar o id da proposta(get) e trazer os dados da proposta e alimentar o formulario com os dados retornado.
            */
          if (heAssociado) {
            this.propostaAssossiada = heAssociado;
            stepper.next();
          } else {
            //01 Se true, dispara o Modal informativo.
            if (this.dadosOperadoraDM?.externalRegistrationLink) {
              this.aoAbrirModalInformativoParaAssociar(this.dadosOperadoraDM);
              return;
            }
            //02
            //filtro temporario, esta filtrando somente adservip porque foi desenvolvido somente para ele. o restante das entidade nao foram desenvolvidas,
            //sao formulario diferentes. ou seja foi desenvolvido somente "ADSERVIP"
            else if (this.nomeEntidade.trim().toUpperCase() === 'ADSERVIP') {
              this.buscarDadosPropostaEntidadeFormularioAdservip();
            } else if (this.nomeEntidade.trim().toUpperCase() === 'ABJE') {
              this.buscarDadosPropostaEntidadeFormularioAbje();
            } else {
              stepper.next();
            }
          }
          this.abrirModalReajusteUdemo();
        },
        error => {
          this._errorLoggingService.logError('Erro ao associar ou não a proposta do beneficiário.', error, {
            contexto: 'Erro ao usar o serviço de associar ou não a proposta do beneficiário.',
            dados: {
              proposalId: this.idProposta,
              holderProposalId: this.titularDaProposta,
              isAssociate: heAssociado,
            },
          });
        },
      );
  }

  public get ehColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  buscarDadosPropostaEntidadeFormularioAdservip() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;

    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAdservip(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.realizarCadastro = false;
            this.retornoDadosFormularioEntidade = data;
            setTimeout(() => {
              this.abrirModalFormularioInscricaoEntidade();
            }, 0);
          }
        },
        error: error => {
          if (error.status == 404) {
            this.realizarCadastro = true;
            setTimeout(() => {
              this.abrirModalFormularioInscricaoEntidade();
            }, 0);
          }
          this.pararSpinner();
        },
      });
  }

  validarCampos(stepper: MatStepper) {
    switch (stepper.selectedIndex) {
      case 0:
        stepper.next();
        break;
      case 1:
        stepper.next(); //associadao ou nao
        break;
      case 2:
        //dados do Titular
        this._beneficiarioPropostaVM = this.formBeneficiario.value;
        this.onSalvarDadosBeneficiario(stepper);
        break;
      //endereco
      case 3:
        this.cadastrarEndereco(stepper);
        break;
      case 4:
        stepper.next();
        break;
      default:
        stepper.next();
        break;
    }
    this.fecharModalConcordo();
  }

  criarFormBeneficario() {
    this.formBeneficiario = this.formBuilder.group({
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(250),
        // VerificaNome,
      ]),
      id: new FormControl(''),
      proposalId: new FormControl(''),
      birthDate: new FormControl('', [Validators.required]),
      cpf: new FormControl('', [Validators.required, CustomValidators.validaCPF, Validators.maxLength(11)]),
      professionId: new FormControl(null, [Validators.required]),
      otherProfession: new FormControl(''),
      sex: new FormControl(1, [Validators.required]),
      gender: new FormControl(null),
      otherGender: new FormControl(''),
      civilStatusId: new FormControl(null, [Validators.required]),
      mobilePhone: new FormControl(''),
      homePhone: new FormControl(''),
      businessPhone: new FormControl(''),

      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaEmail,
      ]),
      mothersName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaNome,
      ]),
      cns: new FormControl('', [Validators.required, Validators.maxLength(17)]),
      previousOperator: new FormControl(''),
      stateId: new FormControl(null),
      cityId: new FormControl(''),
      analysisPeriodReductionCheck: new FormControl(false, [Validators.required]),
      proposalType: new FormControl(null),
      dwellTime: new FormControl(null),
      step: new FormControl(null),
    });
  }

  criarFormDadosBancarios() {
    this.formGrupDadosBancarios = this.formBuilder.group({
      bankId: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
      agency: new FormControl(null, [Validators.required, Validators.maxLength(10)]),
      agencyDigit: new FormControl(null, [Validators.maxLength(10)]),
      account: new FormControl(null, [Validators.required, Validators.maxLength(12)]),
      accountDigit: new FormControl(null, [Validators.required, Validators.maxLength(12)]),
      id: new FormControl(null),
      holderProposalId: new FormControl(null),
      step: new FormControl(null),
      proposalId: new FormControl(''),
      otherBankId: new FormControl(''),
      automaticDebit: new FormControl(''),
    });
  }

  buscarProfissao() {
    this._listaAux.listaProfissao().subscribe(data => {
      this.listaProfissao = data && data;
    });
  }

  buscarListaEstatusCivil() {
    this._listaAux.LitaEstadosCivil().subscribe(data => {
      this.listaEstatusCivil = data && data;
    });
  }

  buscarListaEstados() {
    this._geo.ListStates().subscribe((data: any) => {
      this.listaEstados = data && data;
      const indexOutro = this.listaEstados.findIndex((item: {name: string}) => item.name === 'Outro');

      if (indexOutro > -1) {
        const outro = this.listaEstados.splice(indexOutro, 1)[0];
        this.listaEstados.push(outro);
      }
    });
  }

  buscarBancos(): Promise<any> {
    return new Promise(resolve => {
      this._listaAux.listarBancos().subscribe(data => {
        this.listaDeBancosConveniados = data?.filter((x: any) => x.automaticDebit == true || x.number == 0);
        this.listaBancos = data;
        resolve(data);
      });
    });
  }

  listaGeneros() {
    this._listaAux.listaGeneros().subscribe(data => {
      this._listaGeneros = data && data;
    });
  }

  onFieldChange() {
    if (this.formTouched) {
      this.condionalDeObrigatoriedadeContatos();
      this.errorMessage = !this.isFormValid();
    }
  }

  buscarEnum() {
    this._enumService.getEnumsContract().subscribe(data => {
      const tipoContratacao = data.find(
        (enumObj: {enumType: string}) => enumObj.enumType === 'ContractModalityProductEnum',
      );

      const tipoProposta = data.find((enumObj: {enumType: string}) => enumObj.enumType === 'ProposalTypeEnum');

      // Lista inicial filtrando "InclusaoDependente" (para titular)
      let lista = tipoProposta?.values?.filter((x: any) => x.name !== 'InclusaoDependente') || [];

      //  Se for ODONTO, mantém apenas "NovaAdesao"
      if (this.heOdonto) {
        lista = lista.filter((x: any) => x.value === 1);
      }
      this.listaEnumTipoProposta = lista;
    });
  }

  onChangeProfession(profissaoId: any) {
    const profissaoSelecionada = this.listaProfissao.find(p => p.id === profissaoId);

    if (profissaoSelecionada) {
      const nome = profissaoSelecionada.name;
      this.isOtherProfession = this.outrosValores.includes(nome.toLowerCase());
    }

    if (!this.isOtherProfession) {
      this.formBeneficiario.controls['otherProfession'].reset();
    }
  }

  onChangeGender(idGenero: any) {
    const generoSelecionado = this._listaGeneros.find(p => p.value === idGenero)?.description;

    if (generoSelecionado) {
      this.isOtherGender = this.outrosValores.includes(generoSelecionado.toLowerCase());
    } else {
      this.formBeneficiario.controls['otherGender'].setValue('');
    }
  }

  inserirValidadoresAntigaOperadora(mostrarFormulario: boolean) {
    this.analiseOperadoraAnterior = mostrarFormulario;
    const camposParaValidar = ['previousOperator', 'dwellTime', 'stateId', 'cityId'];

    camposParaValidar.forEach(campo => {
      const control = this.formBeneficiario.get(campo);

      if (mostrarFormulario) {
        control?.setValidators([Validators.required]);

        control?.markAsTouched({onlySelf: true});
        control?.markAsDirty({onlySelf: true});
        control?.updateValueAndValidity({onlySelf: true, emitEvent: false});
        if (!control?.value) {
          control?.setErrors({required: true}, {emitEvent: false});
        }
      } else {
        control?.clearValidators();
        control?.setErrors(null, {emitEvent: false});
        control?.markAsUntouched({onlySelf: true});
        control?.markAsPristine({onlySelf: true});
        control?.reset('', {emitEvent: false});
      }

      control?.updateValueAndValidity({onlySelf: true});
    });

    this.cdr.detectChanges();
  }

  onChangeState($event: any) {
    if ($event) {
      this.listarCidadesPorEstado($event);
    } else {
      this.formBeneficiario.patchValue({cityId: null});
      this.listaCidades = [];
    }
  }

  async listarCidadesPorEstado(id: any[]): Promise<any> {
    if (id) {
      let estado = [];
      estado.push(id);
      this._geo.ListCitiesByStates(estado).subscribe((data: any) => {
        this.listaCidades = data && data;
      });
    }
  }

  condionalDeObrigatoriedadeContatos(): boolean {
    const email = this.formBeneficiario.controls['email'].value;
    const businessPhone = this.formBeneficiario.controls['businessPhone'].value;
    const homePhone = this.formBeneficiario.controls['homePhone'].value;
    const mobilePhone = this.formBeneficiario.controls['mobilePhone'].value;

    if (!email && !mobilePhone && !businessPhone && !homePhone) {
      this.formBeneficiario
        .get('email')
        ?.setValidators([
          Validators.required,
          Validators.email,
          Validators.minLength(2),
          Validators.maxLength(250),
          VerificaEmail,
        ]);
      this.formBeneficiario.get('mobilePhone')?.setValidators([Validators.required]);
      this.formBeneficiario.get('businessPhone')?.setValidators([Validators.required]);
      this.formBeneficiario.get('homePhone')?.setValidators([Validators.required]);

      this.formBeneficiario.get('email')?.updateValueAndValidity();
      this.formBeneficiario.get('mobilePhone')?.updateValueAndValidity();
      this.formBeneficiario.get('businessPhone')?.updateValueAndValidity();
      this.formBeneficiario.get('homePhone')?.updateValueAndValidity();

      return true;
    } else {
      this.formBeneficiario.get('email')?.clearValidators();
      this.formBeneficiario.get('mobilePhone')?.clearValidators();
      this.formBeneficiario.get('businessPhone')?.clearValidators();
      this.formBeneficiario.get('homePhone')?.clearValidators();

      if (email) {
        this.formBeneficiario
          .get('email')
          ?.setValidators([Validators.email, Validators.minLength(2), Validators.maxLength(250), VerificaEmail]);
      }
      if (mobilePhone) {
        this.formBeneficiario.get('mobilePhone')?.setValidators([]);
      }
      if (businessPhone) {
        this.formBeneficiario.get('businessPhone')?.setValidators([]);
      }
      if (homePhone) {
        this.formBeneficiario.get('homePhone')?.setValidators([]);
      }

      this.formBeneficiario.get('email')?.updateValueAndValidity();
      this.formBeneficiario.get('mobilePhone')?.updateValueAndValidity();
      this.formBeneficiario.get('businessPhone')?.updateValueAndValidity();
      this.formBeneficiario.get('homePhone')?.updateValueAndValidity();

      return false;
    }
  }

  condicionalDeObrigatoriedadeOperadoraAnterior(): boolean {
    return this.analiseOperadoraAnterior;
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formBeneficiario.valid;
  }

  private validarInfoDependente(listaDependentes: any[]): boolean {
    this.listaNomeDependenteInvalido = [];

    for (const dependente of listaDependentes) {
      const invalido =
        !dependente.name?.trim() ||
        !dependente.cpf?.trim() ||
        !dependente.birthDate ||
        !dependente.mothersName ||
        !dependente.sex ||
        !dependente.cns ||
        !dependente.civilStatusId;

      if (invalido) {
        const nome = dependente.name?.trim() || 'Sem nome';

        if (!this.listaNomeDependenteInvalido.includes(nome)) {
          this.listaNomeDependenteInvalido.push(nome);
        }
      }
    }

    return this.listaNomeDependenteInvalido.length === 0;
  }

  preencherDadosDependente(): boolean {
    // Calcula o valor total da cotação
    this.listaDependentes = [];
    this.listaDependentes = this._dependenteComponentViewChild?.listaDependentes?.map(dependente => ({
      id: dependente.id && dependente.id.toString().startsWith('temp-') ? null : dependente.id,
      holderProposalId: this.titularDaProposta,
      civilStatusId: dependente.civilStatusId,
      name: dependente.name || ' ',
      birthDate: dependente.birthDate || new Date().toISOString(),
      cpf: dependente.cpf,
      sex: dependente.sex || 1,
      mothersName: dependente.mothersName,
      cns: dependente.cns,
      branchCompanyContractKinshipId: dependente.branchCompanyContractKinshipId,
      priceValue: dependente.priceValue || 0,
      proposalType: dependente.proposalType,
    }));
    this.listaDependentes = this._dependenteComponentViewChild?.listaDependentes || [];
    if (this.listaDependentes.length > 0) {
      if (!this.checarDadosOperadoraAnteriorDependente(this.listaDependentes)) {
        return false;
      } else if (!this.validarInfoDependente(this.listaDependentes)) {
        this.toastr.warning(
          `Por favor, preencha todos os campos obrigatórios do(s) dependente(s): ${this.listaNomeDependenteInvalido.join(
            ', ',
          )}.`,
          'Atenção!',
        );
        this.pararSpinner();
        return false;
      }
    }
    return true;
  }

  validarCamposReducaoCarenciaTitular(): boolean {
    const ehReducaoCarencia = this.formBeneficiario.controls['analysisPeriodReductionCheck'].value;
    const estadoReducaoCarencia = this.formBeneficiario.controls['stateId'].value;
    const cidadeReducaoCarencia = this.formBeneficiario.controls['cityId'].value;
    const operadoraAnteriorReducaoCarencia = this.formBeneficiario.controls['previousOperator'].value;
    const tempoPermanenciaReducaoCarencia = this.formBeneficiario.controls['dwellTime'].value;

    const algumCampoPreenchido =
      estadoReducaoCarencia ||
      cidadeReducaoCarencia ||
      operadoraAnteriorReducaoCarencia ||
      tempoPermanenciaReducaoCarencia;

    if (!ehReducaoCarencia && algumCampoPreenchido) {
      return false;
    }

    return true;
  }

  onSalvarDadosBeneficiario(stepper?: MatStepper) {
    this.formTouched = true;

    if (!this.formBeneficiario.valid) {
      this.toastr.warning('Favor, verificar todos os campos obrigatórios');
      this.pararSpinner();
      return;
    }

    if (!this.validarCamposReducaoCarenciaTitular()) {
      this.toastr.warning(
        'Se houver campo preenchido da operadora anterior, selecione a opção que deseja submeter a Redução de Carência.',
      );
      this.pararSpinner();
      return;
    }
    // Limpa campos de análise se a opção estiver desmarcada
    if (!this.formBeneficiario.value.analysisPeriodReductionCheck) {
      this.formBeneficiario.patchValue({
        previousOperator: null,
        dwellTime: null,
        stateId: null,
        cityId: null,
      });
    }

    if (!this.preencherDadosDependente()) {
      return;
    }

    const dadosBeneficiariosVM = this.formBeneficiario.value;
    // Garante que os IDs estão corretos
    dadosBeneficiariosVM.id = this.titularDaProposta;
    dadosBeneficiariosVM.proposalId = this.idProposta;
    dadosBeneficiariosVM.isAssociate = this.jaAssociou_se;
    const holderProposal: any = {
      ...dadosBeneficiariosVM,
      analysisPeriodReductionCheck: this.formBeneficiario.value.analysisPeriodReductionCheck,
    };

    // Adiciona analysisPeriodReduction apenas se analysisPeriodReductionCheck for true
    if (this.formBeneficiario.value.analysisPeriodReductionCheck) {
      holderProposal.analysisPeriodReduction = {
        holderProposalId: this.titularDaProposta,
        previousOperator: dadosBeneficiariosVM?.previousOperator,
        proposalType: dadosBeneficiariosVM?.proposalType,
        dwellTime: dadosBeneficiariosVM?.dwellTime,
        stateId: dadosBeneficiariosVM?.stateId,
        cityId: dadosBeneficiariosVM?.cityId,
      };
    }

    const dadosPropostaVM = {
      proposal: {
        id: this.idProposta,
        preLeadId: this.preleadId,
        dependentInclusion: this.dependentInclusion,
      },
      holderProposal: holderProposal,
      dependents: this.listaDependentes,
    };

    // Remove campos desnecessários do holderProposal
    delete dadosPropostaVM?.holderProposal.stateId;
    delete dadosPropostaVM?.holderProposal.cityId;
    delete dadosPropostaVM?.holderProposal.previousOperator;
    delete dadosPropostaVM?.holderProposal.proposalType;
    delete dadosPropostaVM?.holderProposal.dwellTime;
    this.iniciarSpinner();

    this._propostaCotacaoService
      .cadastrar(dadosPropostaVM, this.isBeneficiary)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: async (data: any) => {
          await this.buscarDadosProposta();
          this.dadosBeneficiarioDM = data;
          this.dadosBeneficiarioDM.holderProposal.proposalType =
            this.dadosBeneficiarioDM.holderProposal?.proposal?.proposalType;

          this.listaDeBeneficiarios = [...this.dadosBeneficiarioDM.dependents, this.dadosBeneficiarioDM.holderProposal];
          this.ehReducaoCarencia =
            this.formBeneficiario.controls['analysisPeriodReductionCheck'].value ||
            this.dadosBeneficiarioDM?.dependents?.some((dependente: any) => dependente.analysisPeriodReductionCheck);

          this.abrirModalReducaoCarencia();
          this.toastr.success('Dados salvos com sucesso!');
          this.toastr.toastrConfig.preventDuplicates = true;
        },
        error: (e: any) => {
          this.toastr.toastrConfig.preventDuplicates = true;
          var mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error('Erro ao tentar cadastrar');
            this.pararSpinner();
            return;
          } else {
            this.toastr.error(mensagemTratada);
            this.pararSpinner();
          }
        },
      });
  }

  async buscarDadosEnderecoProposta(): Promise<any> {
    try {
      const idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
      this._beneficiarioProposaService.dadosEnderecoPorProposta(idProposta).subscribe(data => {
        this.enderecoComponent.preencherFormComponenteSemTabela(data.holderProposal?.addressData);
      });
    } catch (error) {}
  }

  async buscarDadosBancariosProposta(): Promise<any> {
    try {
      const idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
      this.idProposta = idProposta;

      this.buscarBancos();

      const data = await firstValueFrom(this._beneficiarioProposaService.buscarDadosBancarioPorProposta(idProposta));

      this.dadosBancariosTitular = data;
      this.formGrupDadosBancarios.reset();
      this.formGrupDadosBancarios.patchValue(data);

      const outroBancoId = this.listaBancos?.find((x: any) => x.name?.toLowerCase() == 'outro');

      if (!data?.bank?.automaticDebit) {
        this.filtrarBancosNaoConveniados(false);
        this.bancoConveniado = false;
        this.formGrupDadosBancarios.patchValue({
          otherBankId: data.bank.id,
          bankId: outroBancoId?.id,
          automaticDebit: data?.bank?.automaticDebit,
        });
      } else {
        this.bancoConveniado = true;
      }

      return data;
    } catch (error: any) {
      if (error?.status === 404) {
        this._errorLoggingService.logError(
          'Nenhum dado bancário encontrado (404). Continuando fluxo normalmente...',
          error,
          {
            contexto: 'Erro ao buscar dados bancários',
          },
        );
      }
    }
  }

  async cadastrarEndereco(stepper: MatStepper): Promise<void> {
    if (this.somenteLeituraStep) {
      if (this.dependentInclusion) {
        this.tabService.avancarParaProximaAba('declaracaoSaude');
      } else {
        stepper.next();
      }
    } else {
      const formEndereco = this.enderecoComponent?.isFormValid() ?? true;

      if (this.enderecoComponent) {
        this.enderecoComponent.formTouched = true;
        this.enderecoComponent.isFormSubmited = true;
        this.enderecoComponent.showErrorMessage = true;
      }

      if (!formEndereco) {
      this.toastr.warning('Por favor, preencher os campos obrigatórios de Endereço');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }
      const formularioEndereco = this.extrairCamposNecessariosParaEnvioEndereco();

      const dadosEndereco = {
        holderProposalId: this.titularDaProposta,
        proposalId: this.idProposta,
        ...formularioEndereco,
      };
      this._propostaCotacaoService.cadastrarEndereco(dadosEndereco).subscribe({
        next: async retorno => {
          this.pararSpinner();

          //se for Inclusao de dependente nao mostrar o stepo de dados bancarios
          if (!this.dependentInclusion) {
            this.buscarDadosBancariosProposta();
            this.toastr.success('Endereço cadastrado');
            if (stepper) {
              //dados Bancarios
              stepper.next();
            }
          } else {
            if (this.heOdonto) {
              //atualizar para o step de documentacao
              this._beneficiarioPropostaService
                .atualizarStep(this.idProposta, PropostaExternaEnum.DOCUMENTO)
                .subscribe();
            }

            this.seguirPosCadastroDadosBancarios();
          }
        },
        error: (e: any) => {
          this.toastr.toastrConfig.preventDuplicates = true;

          var mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error('Erro ao tentar cadastrar o endereço');
            this.pararSpinner();
            return;
          } else {
            this.toastr.error('Erro ao tentar cadastrar endereço ');
            this.pararSpinner();
          }
        },
      });
    }
  }

  seguirPosCadastroDadosBancarios() {
    if (this.heOdonto) {
      this.tabService.avancarParaProximaAba('documentos');
      return;
    } else {
      this.tabService.avancarParaProximaAba('declaracaoSaude');
      return;
    }
  }

  async cadastrarDadosBancario(stepper: MatStepper) {
    if (this.somenteLeituraStep) {
      this.seguirPosCadastroDadosBancarios();
    } else {
      const dadosBancarioVM = this.formGrupDadosBancarios.value;
      this.iniciarSpinner();
      const idBanco = dadosBancarioVM.bankId;
      dadosBancarioVM.holderProposalId = this.dadosBeneficiarioDM?.holderProposalId || this.titularDaProposta;
      dadosBancarioVM.proposalId = this.dadosBeneficiarioDM?.proposalId || this.idProposta;
      dadosBancarioVM.bankId = null;

      if (!dadosBancarioVM?.automaticDebit) {
        //outro banco
        dadosBancarioVM.bankId = idBanco || dadosBancarioVM.otherBankId;
      } else {
        dadosBancarioVM.bankId = idBanco || idBanco.bankId?.id;
        delete dadosBancarioVM.otherBankId;
      }

      this._beneficiarioProposaService
        .cadastrarDadosBancario(dadosBancarioVM)
        .pipe(finalize(() => this.pararSpinner()))
        .subscribe({
          next: async retorno => {
            if (stepper) {
              //retorno.holderProposal.proposal.step // ele mesmo é = 4, entao deve seguir par ao 5
              //ir para a tela de DS
              //verificar o step que esta retornando para seguir para proximo(CARTA_ORIENTACAO)

              //verficar se for Odonto, nao deve seguir para DS mas sim para docs.
              this.toastr.success('Dados  Bancário cadastrado!');
              this.seguirPosCadastroDadosBancarios();
            }
          },
          error: (e: any) => {
            this.toastr.toastrConfig.preventDuplicates = true;
            this._errorLoggingService.logError('Falha ao buscar dados Bancário cadastrado!', e, {
              contexto: 'Falha ao buscar dados Bancário cadastrado!',
              data: dadosBancarioVM,
            });
            var mensagemTratada = e.message.replace('Error:', '');

            if (mensagemTratada.includes('[object Object]')) {
              this.pararSpinner();
              return;
            } else {
              this.toastr.error(e.message);
              this.pararSpinner();
            }
          },
        });
    }
  }

  private async executarMetodosSequenciasComSeguranca(fn: Function, ...args: any[]) {
    try {
      const resultado = fn.apply(this, args);
      if (resultado instanceof Promise) {
        await resultado;
      }
    } catch (e: any) {
      this.toastr.warning(`Falha ao executar o metodo: ${fn.name}`);
    }
  }

  async buscarDadosProposta(stepper?: MatStepper): Promise<any> {
    let idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    this.idProposta = idProposta;
    try {
      const dataRetornoProposta = await this._propostaCotacaoService.buscarDadosPropostaPorId(idProposta);
      const dadosPropostaVM = await firstValueFrom(dataRetornoProposta);
      this.entidadeId = dadosPropostaVM?.branchCompanyContractId;
      this.nomeEntidade = dadosPropostaVM?.branchCompanyName;
      this.codigoProposta = dadosPropostaVM?.code;
      this.urlEntidade = dadosPropostaVM?.branchCompanyNameURL;
      this.logoEntidade = dadosPropostaVM?.branchCompanyNameLogo;
      this.razaoSocialEntidade = dadosPropostaVM?.branchCompanySocialReason;
      this.tipoProposta = dadosPropostaVM?.proposalType;
      this.preleadId = dadosPropostaVM?.preLeadId;
      this.dadosOperadoraDM = dadosPropostaVM;
      this.tipoProduto = dadosPropostaVM?.productType;
      this.dependentInclusion = dadosPropostaVM?.dependentInclusion;
      this.modalidadeProduto = dadosPropostaVM?.modalityProduct;
      this.dataCriacaoProposta = dadosPropostaVM?.holderProposal.createDate;
      this.nomeTitular = dadosPropostaVM?.holderProposal.name;
      this.cpfTitular = dadosPropostaVM?.holderProposal.cpf;
      this.heOdonto = TipoProduto_E_OperadoraComponent.isOdonto(dadosPropostaVM?.productType);
      this.buscarEnum();

      await this.patchValuebeneficiario(dadosPropostaVM);
      this.separarBeneficiarios(dadosPropostaVM);
      await this.executarMetodosSequenciasComSeguranca(
        this.listarCidadesPorEstado,
        dadosPropostaVM?.holderProposal?.stateId,
      );
      this.mostrarOrientacaoPortabilidade = false;
      this.mostrarOrientacaoSumula = false;
      this.titularDaProposta = dadosPropostaVM?.holderProposal?.id;

      if (!this.dependentInclusion) {
        await this.executarMetodosSequenciasComSeguranca(this.buscarDadosBancariosProposta.bind(this));
      }
      await this.executarMetodosSequenciasComSeguranca(this.buscarDadosEnderecoProposta.bind(this));

      await this.executarMetodosSequenciasComSeguranca(this.compartilharDadosEntreComponent, dadosPropostaVM);

      this.redirecionamentoDeStep(dadosPropostaVM?.step);
    } catch (error: any) {
      this.pararSpinner();
      if (error.status == 400) {
        this.toastr.info(error.message);
      } else {
        this.toastr.error(error.message);
      }
    }
  }

  redirecionamentoDeStep(step: number) {
    let index!: number;
    // Aguarde até o stepper estar pronto
    if (!this.stepper || !this.stepper._steps || this.stepper._steps.length === 0) {
      setTimeout(() => this.redirecionamentoDeStep(step), 50);
      return;
    }

    // Se for inclusão de dependente e o step for de banco, pula para o próximo passo
    if (this.dependentInclusion && step === PropostaExternaEnum.BENEFICIARIO_BANCO) {
      this.seguirPosCadastroDadosBancarios();
    }
    // se for inclusao de  dependente e o step for ZERO(0) dev ocultar a secao de É associado e seguir direto para a ela de beneficiario step = 2
    if (this.dependentInclusion) {
      index = this.ocultarHeAssociadoParaInclusaoDependente(step);
    }

    switch (step) {
      case 0:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.BENEFICIARIO_CONCORDO);
        index = PropostaExternaEnum.BENEFICIARIO_CONCORDO;
        break;
      case 1:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.BENEFICIARIO_ASSOCIADO);
        index = PropostaExternaEnum.BENEFICIARIO_ASSOCIADO;
        break;
      case 2:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.BENEFICIARIO_TITULAR);
        index = PropostaExternaEnum.BENEFICIARIO_TITULAR;
        break;
      case 3:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.BENEFICIARIO_ENDERECO);
        index = PropostaExternaEnum.BENEFICIARIO_ENDERECO;
        break;
      case 4:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.BENEFICIARIO_BANCO);
        index = PropostaExternaEnum.BENEFICIARIO_BANCO;
        break;
      case 5:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CARTA_ORIENTACAO);
        index = PropostaExternaEnum.CARTA_ORIENTACAO;
        break;
      case 6:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.PERGUNTAS);
        index = PropostaExternaEnum.PERGUNTAS;
        break;
      case 7:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.TERMO);
        index = PropostaExternaEnum.TERMO;
        break;
      case 8:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.QUESTIONARIO);
        index = PropostaExternaEnum.QUESTIONARIO;
        break;
      case 9:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.DOCUMENTO);
        index = PropostaExternaEnum.DOCUMENTO;
        break;
      case 10:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.ANALISE);
        index = PropostaExternaEnum.ANALISE;
        break;
      case 11:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.RETORNO_DOCUMENTO);
        index = PropostaExternaEnum.RETORNO_DOCUMENTO;
        break;
      case 12:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.VIDEO_CONFERENCIA);
        index = PropostaExternaEnum.VIDEO_CONFERENCIA;
        break;
      case 13:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.RETORNO_DS);
        index = PropostaExternaEnum.RETORNO_DS;
        break;
      case 14:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.PAGAMENTO);
        index = PropostaExternaEnum.PAGAMENTO;
        break;
      case 15:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.ANALISE_PAGAMENTO);
        index = PropostaExternaEnum.PAGAMENTO;
        break;
      case 16:
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CONCLUSAO);
        index = PropostaExternaEnum.CONCLUSAO;
        break;
      default:
        this.tabService.definirAbaAtivaPorNumero(step);
        index = step;
        break;
    }

    if (index >= 0 && index < this.stepper._steps.length) {
      this.stepper.selectedIndex = index;
    }
  }

  async patchValuebeneficiario(jsonData: any): Promise<any> {
    this.marcarCamposComoTouched(this.formBeneficiario);
    this.inserirValidadoresAntigaOperadora(jsonData.holderProposal?.analysisPeriodReductionCheck);
    this.listarCidadesPorEstado(jsonData.holderProposal?.analysisPeriodReduction?.stateId);
    this.propostaAssossiada = jsonData.holderProposal?.isAssociate;

    // se analysisPeriodReductionCheck for true exibir s documentos
    if (jsonData.holderProposal?.analysisPeriodReductionCheck) {
      this.analiseOperadoraAnterior = true;
    } else {
      this.analiseOperadoraAnterior = false;
    }
    this.titularDaProposta = jsonData.holderProposal?.id;
    this.stepAtual = jsonData.step;
    this.formBeneficiario.patchValue({
      id: jsonData.id, //Id do titular
      step: jsonData.step,
      proposalId: jsonData.holderProposal?.proposalId,
      name: jsonData.holderProposal.name,
      birthDate: new Date(jsonData.holderProposal.birthDate),
      cpf: jsonData.holderProposal.cpf,
      professionId: jsonData.holderProposal?.professionId,
      otherProfession: jsonData.holderProposal.otherProfession,
      sex: jsonData.holderProposal.sex,
      gender: jsonData.holderProposal.gender,
      otherGender: jsonData.holderProposal.otherGender,
      civilStatusId: jsonData.holderProposal.civilStatusId,
      mobilePhone: jsonData.holderProposal.mobilePhone,
      homePhone: jsonData.holderProposal.homePhone,
      businessPhone: jsonData.holderProposal.businessPhone,
      email: jsonData.holderProposal.email,
      mothersName: jsonData.holderProposal.mothersName,
      cns: jsonData.holderProposal.cns,

      previousOperator: jsonData.holderProposal?.analysisPeriodReduction?.previousOperator,
      stateId: jsonData.holderProposal?.analysisPeriodReduction?.stateId,
      cityId: jsonData.holderProposal?.analysisPeriodReduction?.cityId,
      analysisPeriodReductionCheck: jsonData.holderProposal?.analysisPeriodReductionCheck,
      proposalType: jsonData.holderProposal?.analysisPeriodReduction?.proposalType || jsonData?.proposalType,
      dwellTime: jsonData.holderProposal?.analysisPeriodReduction?.dwellTime,
    });

    //Remover additiveSignatures da lista de dependentes
    const dependentesSemAdditiveSignatures =
      jsonData.holderProposal?.dependentsProposal?.map((dependente: any) => {
        const {additiveSignatures, ...dependenteSemAdditiveSignatures} = dependente;
        return dependenteSemAdditiveSignatures;
      }) || [];
    if (!this.ehColaborador) {
      this._dependenteComponentViewChild.listaDependentes = dependentesSemAdditiveSignatures;
    }

    const passoDadosBeneficiarios = PropostaExternaEnum.BENEFICIARIO_TITULAR;
    if (this.stepAtual > passoDadosBeneficiarios) this.somenteLeituraFormulario();
  }

  filtrarBancosNaoConveniados(automaticDebit: boolean) {
    //outro Banco
    this.listaDeBancosNaoConveniados =
      this.listaBancos && this.listaBancos.filter((x: any) => x.automaticDebit == automaticDebit && x.number != 0);
  }

  changeOutroBanco(dadosBancario: any, template: TemplateRef<any>) {
    const outroBanco = dadosBancario?.name?.toLowerCase();
    if (outroBanco == 'outro') {
      this.filtrarBancosNaoConveniados(false);
      this.formGrupDadosBancarios.get('otherBankId')?.setValidators([Validators.required]);
      this.formGrupDadosBancarios.get('automaticDebit')?.setValue(false);
      this.modalRef = this.modalService.show(template, {class: 'modal-lg'});
    } else {
      this.listaDeBancosConveniados =
        this.listaBancos && this.listaBancos.filter((x: any) => x.automaticDebit == true || x.number == 0);
      this.bancoConveniado = true;
      this.formGrupDadosBancarios.get('automaticDebit')?.setValue(true);
      this.formGrupDadosBancarios.get('otherBankId')?.setValue(null);
      this.formGrupDadosBancarios.get('otherBankId')?.clearValidators();
      this.formGrupDadosBancarios.get('otherBankId')?.updateValueAndValidity();
    }
  }

  fecharModal() {
    this.bancoConveniado = false;
    this.modalService.hide();
  }

  public aoFecharModalInscricao(formularioPreenchidoEValido: boolean): void {
    if (!this.modalInscricaoEntidadeRef) {
      return;
    }

    this.modalInscricaoEntidadeRef.hide();
    this.modalAberto = false;

    // Formulário preenchido e válido: avança para beneficiário
    if (formularioPreenchidoEValido) {
      this.stepper.selectedIndex = PropostaExternaEnum.BENEFICIARIO_TITULAR;
    } else {
      // Formulário não preenchido ou inválido: permanece em "É Associado"
      this.toastr.warning('Por favor, preencha o formulário ou confirme os dados para continuar.', 'Atenção');
      this.stepper.selectedIndex = PropostaExternaEnum.BENEFICIARIO_ASSOCIADO;

      //Atualiza o step para He Associado, mantem no step
      this._beneficiarioPropostaService
        .atualizarStep(this.idProposta, PropostaExternaEnum.BENEFICIARIO_ASSOCIADO)
        .subscribe();
    }
  }

  fecharModalConcordo() {
    this.modalService.hide();
  }

  private compartilharDadosEntreComponent(dataDM: any) {
    this.dadosParaCompartilharBeneficiario = [
      {
        dadosBeneficiario: dataDM,
        dadosBancarios: {
          dadosBancariosTitular: this.dadosBancariosTitular,
          listaBancosCompleta: this.listaBancos,
          bancosConveniados: this.listaDeBancosConveniados,
          bancosNaoConveniados: this.listaDeBancosNaoConveniados,
        },
      },
    ];

    this._compartilharDadosEntreComponentsService?.enviarDadosParaOutroComponent(
      this.dadosParaCompartilharBeneficiario,
    );

    setTimeout(() => {
      if (this.dadosParaCompartilharBeneficiario[0]?.dadosBeneficiario?.step == 0) {
        if (!this.ehColaborador) {
          this.abrirModalManual();
        } else {
          this.stepper?.next();
        }
      }
    });
  }

  campoDataSelecionado(event: FocusEvent, index?: number) {
    this.inputDataSelecionado = true;

    if (index !== undefined && index !== null) {
      this._campoDataService.campoDataSelecionado(event, undefined, this.datepickersArray, index);
    } else {
      this._campoDataService.campoDataSelecionado(event, this.datepicker, undefined, index);
    }
  }

  esconderCalendario(index?: number) {
    if (index !== null && index !== undefined) {
      if (this.inputDataSelecionado === true) {
        this._campoDataService.esconderCalendario(undefined, this.datepickersArray, index);
      }
      return;
    }
    if (this.inputDataSelecionado === true) {
      this._campoDataService.esconderCalendario(this.datepicker, undefined, index);
    }
  }

  mostrarCalendario(index?: number) {
    this._campoDataService.inputDataSelecionado = false;
    this.inputDataSelecionado = false;
    if (index !== null && index !== undefined) {
      this._campoDataService.mostrarCalendario(undefined, this.datepickersArray, index);
      return;
    }
    if (this.datepicker) {
      this._campoDataService.mostrarCalendario(this.datepicker, undefined, index);
    }
  }

  formatarCampoData(valor: string, campoId: string | number) {
    this._campoDataService.formatarCampoData(valor, campoId);
  }

  camposInvalidos(): string[] {
    const campos = Object.keys(this.formBeneficiario.controls);
    return campos.filter(campo => this.formBeneficiario.get(campo)?.invalid);
  }

  marcarCamposComoTouched(form: FormGroup) {
    this.isFormSubmited = true;
    Object.keys(form.controls).forEach(campo => {
      const controle = form.get(campo);
      controle?.markAsTouched();
      controle?.updateValueAndValidity();
    });
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  abrirModalManual() {
    this.modalManualRef = this.modalService.show(this.modalManual, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'modalManualBeneficiario',
    });
    this.pararSpinner();
  }

  async concordarManual() {
    if (this.modalManualRef) {
      this.modalManualRef.hide();
      this.checkboxManualBeneficiario = true;
    }
    this.separarBeneficiarios(this.dadosParaCompartilharBeneficiario[0]?.dadosBeneficiario);
    await this.verificarNovosDependentesComSumulaPortabilidade();
    if (this.mostrarPortabilidade == false && this.mostrarSumula == false) {
      if (this.dependentInclusion) {
        this.ocultarHeAssociadoParaInclusaoDependente(this.stepAtual);
      } else {
        this.stepper.next();
      }
    }
  }

  /**
    Pula steps iniciais (Concordo e É Associado) indo direto para Beneficiário Titular.
 */
  private ocultarHeAssociadoParaInclusaoDependente(step: number): number {
    const stepsParaPular = [PropostaExternaEnum.BENEFICIARIO_CONCORDO, PropostaExternaEnum.BENEFICIARIO_ASSOCIADO];

    if (stepsParaPular.includes(step)) {
      const novoStep = PropostaExternaEnum.BENEFICIARIO_TITULAR;
      this.stepper.selectedIndex = novoStep;
      return novoStep;
    }

    return step;
  }

  abrirModalPortabilidade() {
    this.modalPortabilidadeRef = this.modalService.show(this.modalPortabilidade, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'portabilidade',
    });
  }

  abrirModalSumula21() {
    this.modalSumula21Ref = this.modalService.show(this.modalSumula21, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'sumula',
    });
  }

  abrirModalReducaoCarencia() {
    let assinaturaReducaoCarencia: boolean = false;
    this.listaDeBeneficiarios?.forEach((item: any) => {
      if (
        item.analysisPeriodReductionCheck &&
        (item.proposalType === TipoPropostaEnum.NOVA_ADESAO || item.proposalType === TipoPropostaEnum.REDUCAO_CARENCIA)
      ) {
        assinaturaReducaoCarencia = true;
      }
    });
    if (assinaturaReducaoCarencia && this.ehReducaoCarencia && !this.ehColaborador) {
      this.preencherModalReducaoCarencia();
      this.modalReducaoCarenciaRef = this.modalService.show(this.modalReducaoCarencia, {
        backdrop: 'static',
        class: 'modal-xl',
        id: 'reducao-carencia',
      });
    } else {
      this.verificarNovosDependentesComSumulaPortabilidade();
    }
  }

  separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;
    this.entidadeProposta = dados.branchCompanyName;
    this.codigoProposta = dados.code;

    if (beneficiario) {
      // TITULAR
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;

      const titularJaExiste = this.listaDeBeneficiarios.some(b => b.id === dadosTitular.id);
      if (!titularJaExiste) {
        this.listaDeBeneficiarios.push({
          ...dadosTitular,
          isDependent: false,
          proposalType: dados.proposalType,
        });
      }
      // DEPENDENTES
      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal.forEach((dependente: any) => {
          const dependenteJaExiste = this.listaDeBeneficiarios.some(b => b.id === dependente.id);

          if (!dependenteJaExiste) {
            this.listaDeBeneficiarios.push({
              ...dependente,
              isDependent: true,
            });
          }
        });
      }
    }
  }

  fecharModalPortabilidade() {
    if (this.modalPortabilidadeRef) {
      if (this.mostrarSumula) {
        this.modalPortabilidadeRef.hide();
      } else {
        if (this.dependentInclusion) {
          this.ocultarHeAssociadoParaInclusaoDependente(this.stepAtual);
        } else {
          this.atualizarStepParaAssociado();
        }
      }
    }
  }

  async concordarSumula(): Promise<any> {
    try {
      await this.assinarOrientacao(TipoPropostaEnum.SUMULA);
      this.modalSumula21Ref?.hide();
      this.checkboxSumula = true;

      if (this.dependentInclusion) {
        this.ocultarHeAssociadoParaInclusaoDependente(this.stepAtual);
      } else {
        this.atualizarStepParaAssociado();
      }
    } catch (error) {
      console.error('Erro modal termo orientacao súmula 21:', error);
    }
  }

  async concordarReducaoCarencia(): Promise<any> {
    try {
      await this.assinarOrientacao(TipoPropostaEnum.NOVA_ADESAO);
      this.modalReducaoCarenciaRef?.hide();
      this.checkboxReducaoCarencia = true;
      this.verificarNovosDependentesComSumulaPortabilidade();
    } catch (error) {
      console.error('Erro modal termo aditivo de redução de carencia:', error);
    }
  }

  async concordarPortabilidade(): Promise<any> {
    try {
      await this.assinarOrientacao(TipoPropostaEnum.PORTABILIDADE);
      this.modalPortabilidadeRef?.hide();
      this.checkboxPortabilidade = true;
      this.fecharModalPortabilidade();
    } catch (error) {
      console.error('Erro modal termo orientacao portabilidade:', error);
    }
  }

  async assinarOrientacao(tipoProposta: TipoPropostaEnum): Promise<any> {
    this.iniciarSpinner();
    let beneficiariosComAditivos = [];
    let tipoDeModal: any = null;

    if (tipoProposta == TipoPropostaEnum.PORTABILIDADE) {
      tipoDeModal = TipoModalAssinaturaEnum.ORIENTACAO;
      beneficiariosComAditivos = this.listaDeBeneficiarios.filter(
        (tipoDeProposta: any) => tipoDeProposta.proposalType === TipoPropostaEnum.PORTABILIDADE,
      );
    } else if (tipoProposta == TipoPropostaEnum.SUMULA) {
      tipoDeModal = TipoModalAssinaturaEnum.ORIENTACAO;
      beneficiariosComAditivos = this.listaDeBeneficiarios.filter(
        (tipoDeProposta: any) => tipoDeProposta.proposalType === TipoPropostaEnum.SUMULA,
      );
    } else if (tipoProposta == TipoPropostaEnum.NOVA_ADESAO) {
      tipoDeModal = TipoModalAssinaturaEnum.REDUCAO_CARENCIA;
    }

    if (beneficiariosComAditivos.length > 0) {
      beneficiariosComAditivos.forEach((beneficiario: any) => {
        this.objModalAditivo = {
          proposalId: this.idProposta,
          proposalType: tipoProposta,
          modalType: tipoDeModal,
        };
        // Se for dependente
        if (beneficiario.holderProposalId) {
          this.objModalAditivo.dependentProposalId = beneficiario.id;
        }
        // Se for titular
        else {
          this.objModalAditivo.holderProposalId = beneficiario.id;
        }

        this._beneficiarioProposaService
          .assinarModaisAditivos(this.objModalAditivo)
          .pipe(
            finalize(() => {
              this.pararSpinner();
            }),
          )
          .subscribe({
            next: data => {
              let dadosRecebidos = data && data;
              this.atualizarAssinatura(dadosRecebidos);
              this.toastr.success('Termo de orientação assinado com sucesso.');
              this.toastr.toastrConfig.preventDuplicates = true;
              this.verificarNovosDependentesComSumulaPortabilidade();
            },
            error: error => {
              this._errorLoggingService.logError(
                'Erro ao assinar a carta de orientação (portabilidade/súmula) da proposta externa',
                error,
                {
                  contexto:
                    'Falha para assinar o modal da carta de orientação (portabilidade/súmula) da proposta externa na aba de beneficiários.',
                  dadosEnviados: {
                    ObjetoEnviado: this.objModalAditivo,
                  },
                },
              );
              return false;
            },
          });
      });
    } else {
      this.objModalAditivo = {
        holderProposalId: this.titularDaProposta,
        proposalId: this.idProposta,
        proposalType: tipoProposta,
        modalType: tipoDeModal,
      };

      this._beneficiarioProposaService
        .assinarModaisAditivos(this.objModalAditivo)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe({
          next: data => {
            let dadosRecebidos = data && data;
            this.atualizarAssinatura(dadosRecebidos);
            this.toastr.success('Termo de Redução de Carência assinado com sucesso.');
            this.toastr.toastrConfig.preventDuplicates = true;
          },
          error: error => {
            this._errorLoggingService.logError(
              'Erro ao assinar o aditivo de Redução de Carência da proposta externa',
              error,
              {
                constexto:
                  'Falha para assinar o modal de redução de carência da proposta externa na aba de beneficiários.',
                dadosEnviados: {
                  ObjetoEnviado: this.objModalAditivo,
                },
              },
            );
          },
        });
    }
  }

  preencherModalReducaoCarencia() {
    this.listaBeneficiariosCarencias = [];
    this.listaDeBeneficiarios.forEach((beneficiario: any) => {
      if (beneficiario.analysisPeriodReductionCheck) {
        const reducaoCarencia = beneficiario.analysisPeriodReduction;

        const dataNascimento = new Date(beneficiario.birthDate);
        const dataNascimentoFormatada = dataNascimento.toLocaleDateString('pt-BR');

        const dataUltimoPagamento = '-';
        // Adicionar à lista de beneficiários com carências
        this.listaBeneficiariosCarencias.push({
          tipoBeneficiario: beneficiario.holderProposalId ? 'Dependente' : 'Titular',
          name: beneficiario.name,
          dataNascimento: dataNascimentoFormatada,
          operadora: reducaoCarencia?.previousOperator || '-',
          tempoPermanencia: reducaoCarencia?.dwellTime ? `${reducaoCarencia.dwellTime}` : '-',
          dataUltimoPagamento: dataUltimoPagamento,
        });
      }
    });
  }

  abrirModalFormularioInscricaoEntidade() {
    this.modalInscricaoEntidadeRef = this.modalService.show(this.modalFormInscricaoEntidade, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'inscricaoEntidade',
    });
  }

  abrirModalConfirmacaoDadosBeneficiario(stepper: MatStepper) {
    if (this.somenteLeituraStep) {
      stepper.next();
    } else {
      if (this.stepAtual > PropostaExternaEnum.BENEFICIARIO_TITULAR) {
        stepper.next();
      } else {
        this.modalConfDadosBeneficiarios = this.modalService.show(this.modalConfirmacaoDadosBeneficiarios, {
          backdrop: 'static',
          class: 'modal-md',
          id: 'modalConfirmacaoDadosBeneficiarios',
        });
      }
    }
  }

  fecharDocFinal() {
    this.modalConfDadosBeneficiarios?.hide();
  }

  somenteLeituraFormulario() {
    this.formBeneficiario.disable();
    this._dependenteComponentViewChild?.somenteLeituraFormularioCompleto();
    this.formBeneficiario.patchValue({proposalType: this.tipoProposta});
  }

  aoAssociarBeneficiario(stepper: MatStepper): void {
    let url = this.dadosOperadoraDM?.urlExternalRegistration;
    if (!url) {
      this.toastr.error('URL de cadastro externo não configurada.');
      return;
    }

    // Adiciona https:// se não tiver protocolo
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = `https://${url}`;
    }

    window.open(url, '_blank');
    this.fecharModalAssociarBeneficiario();
    stepper.next();
  }

  aoAbrirModalInformativoParaAssociar(beneficiario: any): Promise<void> {
    return new Promise(resolve => {
      this.nomeBeneficiario = beneficiario.holderProposal.name;
      this.descricaoTipoProduto = beneficiario.productTypeName;
      this.descricaoModalidadeProduto = beneficiario.modalityProductName;

      this.modalAberto = true;

      this.modalInformativoParaAssociarRef = this.modalService.show(this.modalInformativoParaAssociar, {
        backdrop: 'static',
        class: 'modal-lg',
        id: 'modalInformativoParaAssociar',
      });

      const subscription = this.modalService.onHidden.subscribe(() => {
        this.modalAberto = false;
        subscription.unsubscribe();
        resolve();
      });
    });
  }

  fecharModalAssociarBeneficiario() {
    if (this.modalInformativoParaAssociarRef) {
      this.modalInformativoParaAssociarRef.hide();
      this.modalAberto = false;
    }
  }

  async verificarNovosDependentesComSumulaPortabilidade() {
    const temSumula = this.listaDeBeneficiarios?.some(
      tipoDeProposta => tipoDeProposta.proposalType === TipoPropostaEnum.SUMULA,
    );
    const temPortabilidade = this.listaDeBeneficiarios?.some(
      tipoDeProposta => tipoDeProposta.proposalType === TipoPropostaEnum.PORTABILIDADE,
    );

    let portabilidadeAssinada = this.verificarAssinatura(
      TipoPropostaEnum.PORTABILIDADE,
      TipoModalAssinaturaEnum.ORIENTACAO,
    );
    let sumulaAssinada = this.verificarAssinatura(TipoPropostaEnum.SUMULA, TipoModalAssinaturaEnum.ORIENTACAO);

    if (temPortabilidade && !portabilidadeAssinada) {
      this.mostrarPortabilidade = true;
      this.mostrarSumula = false;
      this.abrirModalPortabilidade();
      return;
    } else if (temSumula && !sumulaAssinada) {
      this.mostrarSumula = true;
      this.mostrarPortabilidade = false;
      this.abrirModalSumula21();
      return;
    } else {
      // Se já foi assinado por algum, não abre modal
      this.mostrarSumula = false;
      this.mostrarPortabilidade = false;
    }
  }

  private verificarAssinatura(tipoDeProposta: TipoPropostaEnum, tipoDeModal: TipoModalAssinaturaEnum): boolean {
    // Verifica se ALGUM beneficiário JÁ assinou esta proposta
    return this.listaDeBeneficiarios?.some(beneficiario => {
      if (beneficiario.proposalType === tipoDeProposta) {
        return beneficiario.additiveSignatures?.some(
          (assinatura: any) => assinatura.proposalType === tipoDeProposta && assinatura.modalType === tipoDeModal,
        );
      }
      return false;
    });
  }

  async reatualizarDadosFormulario(): Promise<any> {
    let idProposta = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    this.idProposta = idProposta;
    const dataRetornoProposta = await this._propostaCotacaoService.buscarDadosPropostaPorId(idProposta);
    const dadosPropostaVM = await firstValueFrom(dataRetornoProposta);
    await this.patchValuebeneficiario(dadosPropostaVM);
    this.errorMessage = false;
    this._dependenteComponentViewChild.novoArquivoCTPSelecionado = false;
    this._dependenteComponentViewChild.novoArquivoCTPSelecionado = false;
  }

  radioButtonReducaoCarenciaSomenteLeitura(): boolean {
    return this.tipoProposta === TipoPropostaEnum.SUMULA || this.tipoProposta === TipoPropostaEnum.PORTABILIDADE;
  }

  buscarDadosPropostaEntidadeFormularioAbje() {
    this.iniciarSpinner();
    this.retornoDadosFormularioEntidade = null;

    this._entidadeService
      .buscarRegsitroEntidadePorPropostaAbje(this.idProposta)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (data) {
            this.realizarCadastro = false;
            this.retornoDadosFormularioEntidade = data;
            setTimeout(() => {
              this.abrirModalFormularioInscricaoEntidade();
            }, 0);
          }
        },
        error: error => {
          if (error.status == 404) {
            this.realizarCadastro = true;
            setTimeout(() => {
              this.abrirModalFormularioInscricaoEntidade();
            }, 0);
          }
          this.pararSpinner();
        },
      });
  }

  atualizarAssinatura(dados: any) {
    let assinaturaRetornada = dados && dados;
    if (assinaturaRetornada) {
      this.listaDeBeneficiarios.find((beneficiario: any) => {
        if (beneficiario.proposalType == assinaturaRetornada.proposalType) {
          beneficiario.additiveSignatures.push(assinaturaRetornada);
        }
      });
    }
  }

  atualizarStepParaAssociado(): boolean {
    if (this.stepAtual == PropostaExternaEnum.BENEFICIARIO_CONCORDO) {
      this.stepAtual = PropostaExternaEnum.BENEFICIARIO_ASSOCIADO;
      this.stepper.next();
      return true;
    }
    return false;
  }

  private checarDadosOperadoraAnteriorDependente(listaDependentes: any): boolean {
    for (const dependente of this.listaDependentes) {
      const nome = dependente.name;
      const reducaoCarenciaAtivo = dependente.analysisPeriodReductionCheck;
      const camposObrigatoriosReducaoCarencia = [
        dependente?.analysisPeriodReduction?.stateId,
        dependente?.analysisPeriodReduction?.cityId,
        dependente?.analysisPeriodReduction?.dwellTime,
        dependente?.analysisPeriodReduction?.previousOperator,
      ];

      const possuiCampoVazio = camposObrigatoriosReducaoCarencia.some(
        campo => campo === null || campo === undefined || campo === '',
      );

      if (reducaoCarenciaAtivo && possuiCampoVazio) {
        this.toastr.warning(
          `Dependente ${nome} com redução de carência precisa preencher os dados da operadora anterior.`,
        );
        this.toastr.toastrConfig.preventDuplicates = true;
        return false;
      }
    }
    return true;
  }

  abrirModalReajusteUdemo() {
    if (this.ehReajusteUdemo(this.dataCriacaoProposta))
      this.modalReajusteUdemoRef = this.modalService.show(this.modalReajusteUdemo, {
        backdrop: 'static',
        class: 'modal-xl',
        id: 'reajusteUdemo',
      });
  }

  async concordarReajusteUdemo(): Promise<any> {
    try {
      this.modalReajusteUdemoRef?.hide();
      this.checkboxReajusteUdemo = true;
      this.fecharModalReajusteUdemo();
    } catch (error) {
      console.error('Erro modal termo orientacao reajuste udemo:', error);
    }
  }

  fecharModalReajusteUdemo() {
    if (this.modalReajusteUdemoRef) {
      this.modalReajusteUdemoRef.hide();
    }
  }

  //mês 9 (reajuste udemo que será aplicado em outubro) mostra aditivo
  ehReajusteUdemo(dataCriacaoProposta: any): boolean {
    return new Date(dataCriacaoProposta).getMonth() + 1 == 9 && this.entidadeProposta == 'UDEMO' ? true : false;
  }

  extrairCamposNecessariosParaEnvioEndereco() {
    const formularioEndereco = this.enderecoComponent?.enderecoForm.value;
    delete formularioEndereco['id'];
    delete formularioEndereco['active'];
    delete formularioEndereco['cityName'];
    delete formularioEndereco['stateName'];
    delete formularioEndereco['internationalCity'];
    delete formularioEndereco['internationalState'];
    delete formularioEndereco['internationalHome'];
    return formularioEndereco;
  }
}
